(() => {
  const angular = window.angular;

  angular.module('app').config(Router);

  Router.$inject = ['$stateProvider'];

  function Router($stateProvider) {
    $stateProvider.state('member.project.Realtime', {
      url: '/realtime',
      template: `<new-front-container path="'real-time'"></new-front-container>`,
      authenticated: true,
      ncyBreadcrumb: {
        label: '{{"entities.tool.__tools.Realtime" | translate}}',
      },
    });
  }
})();
